import Vue from 'vue'
import Vuex from 'vuex'
/* eslint-disable */
import {
  get_
} from 'utils/tools'
import * as actions from './actions'
import * as mutations from './mutations'
import * as getters from './getters'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    loading: false, // 是否展示loading动画
    user: {
      token: get_("token") ? get_("token") : "",
      uid: get_("uid") ? get_("uid") : ""
    },
    areas: [],
    areasLevel2: [],
    cars: {},
    categories: [],
    tracks: {
      current_page: 1,
      data: [],
      last_page: 1,
      per_page: 10,
      total: 0
    },
    collects: {
      current_page: 1,
      data: [],
      last_page: 1,
      per_page: 10,
      total: 0
    },
    collectsStore: {
      current_page: 1,
      data: [],
      last_page: 1,
      per_page: 10,
      total: 0
    },
    messages: {
      business: {
        id: 1,
        title: "交易消息",
        type: 1,
        key: "business",
        link: "/member/setting/message/business",
        data: [],
        unread: false
      },
      system: {
        id: 2,
        title: "系统消息",
        type: 0,
        key: "system",
        link: "/member/setting/message/system",
        data: [],
        unread: false
      },
      interaction: {
        id: 3,
        title: "互动消息",
        type: 2,
        key: "interaction",
        link: "/member/setting/message/interaction",
        data: [],
        unread: false
      }
    },
    articleCategories: [],
    attrs: [],
    /**
     * 行业应用选项卡id
     */
    industry: 0,
    dialogShowIf: false,
    dialogCont: false,
    // 首页新闻弹窗
    inDialog: false,
    isNav: false,
    isFateNav: false,
    isVrNav:false,
    navAllIndex:0,
  },
  getters,
  actions,
  mutations
});
